"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setItemInStorage = exports.getItemFromStorage = void 0;
var constants_1 = require("../constants");
var tempStorage_1 = require("./tempStorage");
var getItemFromStorage = function (key, platform) {
    if (platform === void 0) { platform = (0, tempStorage_1.getValue)('PLATFORM'); }
    switch (platform) {
        case constants_1.PLATFORM.WEB:
            return sessionStorage.getItem(key);
        case constants_1.PLATFORM.MOBILE:
            return (0, tempStorage_1.getValue)(key);
        default:
            throw Error("Invalid PLATFORM ".concat(platform));
    }
};
exports.getItemFromStorage = getItemFromStorage;
var setItemInStorage = function (key, value, platform) {
    if (platform === void 0) { platform = (0, tempStorage_1.getValue)('PLATFORM'); }
    switch (platform) {
        case constants_1.PLATFORM.WEB:
            return sessionStorage.setItem(key, value);
        case constants_1.PLATFORM.MOBILE:
            return (0, tempStorage_1.setValue)(key, value);
        default:
            throw Error("Invalid PLATFORM ".concat(platform));
    }
};
exports.setItemInStorage = setItemInStorage;
//# sourceMappingURL=storage.js.map